import React, { Fragment } from "react";
import { Link, useMatches } from "react-router";
import { useTranslation } from "react-i18next";

interface BreadcrumbMatch {
  pathname: string;
  handle?: { breadcrumb?: string };
}

export const BreadcrumbsComponent = () => {
  const matches = useMatches() as BreadcrumbMatch[];
  const { t } = useTranslation();

  const breadcrumbs = matches.filter((m) => m.handle?.breadcrumb);

  if (breadcrumbs.length === 0) return null;

  return (
    <>
      {breadcrumbs.map((match, index) => {
        const isLast = index === breadcrumbs.length - 1;
        const label = t(match.handle!.breadcrumb!);

        return (
          <Fragment key={match.pathname}>
            {isLast ? <>{label}</> : <Link to={match.pathname}>{label}</Link>}
            {!isLast && <> / </>}
          </Fragment>
        );
      })}
    </>
  );
};
